import { render, staticRenderFns } from "./TableCalculationItem.vue?vue&type=template&id=1855d3ed&"
import script from "./TableCalculationItem.vue?vue&type=script&lang=js&"
export * from "./TableCalculationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports